export const regions = [
  'Ahafo',         'Ashanti',
  'Bono',          'Bono East',
  'Central',       'Eastern',
  'Greater Accra', 'Nort East',
  'Northern',      'Oti',
  'Savannah',      'Upper East',
  'Upper West',    'Volta',
  'Western',       'Western North'
]